import React from "react";
import DonateSection from "../components/DonateBar";
import DonatorsSection from "../components/TeamSection/donators";

const DonatorsPage = () => {
  return (
    <>
      <DonatorsSection />
      <DonateSection isDiv={true} />
    </>
  );
};

export default DonatorsPage;
